<template>
    <q-card flat class="metric-type-filter-popup">
        <div class="c-BasicTab">
            <q-tabs
                v-model="tab"
                align="left"
                indicator-color="transparent"
                :breakpoint="0"
                style="color: var(--v-secondaryText-base);"
            >
                <q-tab v-if="categories" name="categories" :label="Translate('Categories')" />
                <q-tab v-if="datatypes" name="datatypes" :label="Translate('Data Types')" />
                <q-tab v-if="debugMode && sources" name="sources" :label="Translate('Sources')" />
            </q-tabs>
        </div>

        <div class="metric-filter-panels">
            <section v-if="categories && tab === 'categories'" class="metric-filter-panel">
                <div class="metric-filter-header">
                    {{ Translate('Filter by category to focus on data related to specific functional areas.') }}
                    <div class="metric-filter-select-row">
                        <q-btn small flat no-caps color="primary" class="c-SentenceCaseButton" @click="() => allCategoriesSelected ? selectNoCategories() : selectAllCategories()"><span>{{ allCategoriesSelected ? Translate('Deselect All') : Translate('Select All') }}</span></q-btn>
                    </div>
                </div>

                <q-list dense class="metric-filter-list">
                    <q-item
                        v-for="(item, idx) in categories"
                        :key="item.text"
                        class="metric-filter-item"
                        dense
                        clickable
                        v-ripple
                        @click="toggleCategory(idx)"
                    >
                        <q-item-section side @click.stop>
                            <q-checkbox
                                class="metric-filter-checkbox"
                                dense
                                color="primary"
                                :model-value="category_selection.includes(idx)"
                                @update:model-value="toggleCategory(idx)"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label class="metric-filter-label">{{ getItemLabel(item) }}</q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </section>

            <section v-if="datatypes && tab === 'datatypes'" class="metric-filter-panel">
                <div class="metric-filter-header">
                    {{ Translate('Filter by data type (e.g. only show items applicable to durations).') }}
                    <div class="metric-filter-select-row">
                        <q-btn small flat no-caps color="primary" class="c-SentenceCaseButton" @click="() => allDataTypesSelected ? selectNoDataTypes() : selectAllDataTypes()"><span>{{ allDataTypesSelected ? Translate('Deselect All') : Translate('Select All') }}</span></q-btn>
                    </div>
                </div>
                <q-list dense class="metric-filter-list">
                    <q-item
                        v-for="(item, idx) in datatypes"
                        :key="item.text"
                        class="metric-filter-item"
                        dense
                        clickable
                        v-ripple
                        @click="toggleDatatype(idx)"
                    >
                        <q-item-section side @click.stop>
                            <q-checkbox
                                class="metric-filter-checkbox"
                                dense
                                color="primary"
                                :model-value="datatypes_selection.includes(idx)"
                                @update:model-value="toggleDatatype(idx)"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label class="metric-filter-label">{{ getItemLabel(item) }}</q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </section>

            <section v-if="debugMode && sources && tab === 'sources'" class="metric-filter-panel">
                <div class="metric-filter-header">
                    {{ Translate('Filters by source (e.g. only show items applicable to surveys).') }}
                    <div class="metric-filter-select-row">
                        <q-btn small flat no-caps color="primary" class="c-SentenceCaseButton" @click="() => allSourcesSelected ? selectNoSources() : selectAllSources()"><span>{{ allSourcesSelected ? Translate('Deselect All') : Translate('Select All') }}</span></q-btn>
                    </div>
                </div>
                <q-list dense class="metric-filter-list">
                    <q-item
                        v-for="(item, idx) in sources"
                        :key="item.text"
                        class="metric-filter-item"
                        dense
                        clickable
                        v-ripple
                        @click="toggleSource(idx)"
                    >
                        <q-item-section side @click.stop>
                            <q-checkbox
                                class="metric-filter-checkbox"
                                dense
                                color="primary"
                                :model-value="sources_selection.includes(idx)"
                                @update:model-value="toggleSource(idx)"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label class="metric-filter-label">{{ lookupSourceType(item.text) || `(${item.text}) *Missing src` }}</q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </section>
        </div>
    </q-card>

    <!--<q-list>
        <q-list-item-group multiple v-model="selection" color="primary">
            <template v-for="item in columns">
                <q-item-label header v-if="item.divider" :key="item.flat + '2'">
                    {{ item.flat }}
                    <q-space></q-space>
                    <q-btn small flat title="Select All" @click="selectAllOf(item.text)">All</q-btn>
                </q-item-label>

                <q-list-item v-if="!item.divider" :key="item.text" class="mediumdense">
                    <template v-slot:default="{ active }">
                        <q-list-item-action>
                            <q-checkbox :input-value="active"></q-checkbox>
                        </q-item-section>
                        <q-list-item-content>
                            {{ item.flat }}
                        </q-item-section>
                    </template>
                </q-item>
            </template>
        </div>
    </q-list>-->
</template>

<script>
    import common from './common.js';
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                tab: 'categories',
                datatypes_selection: [],
                category_selection: [],
                sources_selection: [],
            }
        },
        props: {
            debugMode: null,
            datatypes: null,
            categories: null,
            sources: null,
            initial_datatypes_selection: null,
            initial_category_selection: null,
            initial_sources_selection: null,
        },
        created() {
            if (!this.categories?.length) {
                if (this.datatypes?.length) this.tab = 'datatypes';
                else if (this.debugMode && this.sources?.length) this.tab = 'sources';
            }
            if (this.initial_datatypes_selection)
                this.datatypes_selection = this.initial_datatypes_selection;
            if (this.initial_category_selection)
                this.category_selection = this.initial_category_selection;
            if (this.initial_sources_selection)
                this.sources_selection = this.initial_sources_selection;
        },
        watch: {
            datatypes_selection: function (newv) {
                this.$emit('datatypes_changed', newv);
                this.notifyIfAnyFilters();
            },
            category_selection: function (newv) {
                this.$emit('categories_changed', newv);
                this.notifyIfAnyFilters();
            },
            sources_selection: function (newv) {
                this.$emit('sources_changed', newv);
                this.notifyIfAnyFilters();
            },
        },
        computed: {
            allDataTypesSelected: function () {
                if (this.datatypes_selection && this.datatypes)
                    return this.datatypes_selection.length >= this.datatypes.length;
                else
                    return false;
            },
            allCategoriesSelected: function () {
                if (this.category_selection && this.categories)
                    return this.category_selection.length >= this.categories.length;
                else
                    return false;
            },
            allSourcesSelected: function () {
                if (this.sources_selection && this.sources)
                    return this.sources_selection.length >= this.sources.length;
                else
                    return false;
            },
        },
        methods: {
            ...methods,
            toggleIndex(arrProp, idx) {
                const cur = [...this[arrProp]];
                const pos = cur.indexOf(idx);
                if (pos >= 0) cur.splice(pos, 1);
                else cur.push(idx);
                this[arrProp] = cur;
            },
            toggleCategory(idx) {
                this.toggleIndex('category_selection', idx);
            },
            toggleDatatype(idx) {
                this.toggleIndex('datatypes_selection', idx);
            },
            toggleSource(idx) {
                this.toggleIndex('sources_selection', idx);
            },
            notifyIfAnyFilters() {
                this.$emit('anyfilters', !(this.allDataTypesSelected && this.allCategoriesSelected && this.allSourcesSelected));
            },
            lookupSourceType(text) {
                return common.sourceTypes[text];
            },
            getItemLabel(item) {
                return this.Translate(item.flat || item.text);
            },
            selectAllDataTypes() {
                this.datatypes_selection = this.datatypes.map((a, i) => i);
            },
            selectNoDataTypes() {
                this.datatypes_selection = [];
            },
            selectAllCategories() {
                this.category_selection = this.categories.map((a, i) => i);
            },
            selectNoCategories() {
                this.category_selection = [];
            },
            selectAllSources() {
                this.sources_selection = this.sources.map((a, i) => i);
            },
            selectNoSources() {
                this.sources_selection = [];
            },
        }
    }
</script>

<style scoped>
    .metric-type-filter-popup {
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        /*
         * QMenu is capped at 65vh by Quasar. Keep the popup below that cap
         * (including the parent card's padding) so QMenu never becomes a
         * second scroll container. A definite height is required here so
         * minmax(0, 1fr) can calculate the list's actual available space.
         */
        height: min(620px, calc(65vh - 24px));
        height: min(620px, calc(65dvh - 24px));
        max-height: min(620px, calc(65vh - 24px));
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
    }

    .metric-type-filter-popup :deep(.c-BasicTab) {
        flex: 0 0 auto;
    }

    .metric-type-filter-popup :deep(.c-BasicTab .q-tabs) {
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .metric-filter-panels {
        min-height: 0;
        overflow: hidden;
    }

    .metric-filter-panel {
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        height: 100%;
        min-height: 0;
        overflow: hidden;
    }

    .metric-filter-header {
        padding: 8px 8px 4px;
        flex: 0 0 auto;
    }

    .metric-filter-select-row {
        margin-top: 4px;
    }

    .metric-filter-list {
        /*
         * This is the only scroll container. The parent's minmax(0, 1fr)
         * track supplies its exact adaptable height.
         */
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .metric-filter-item {
        min-height: 32px;
    }

    .metric-filter-label {
        color: var(--v-primaryText-base);
        font-size: 14px;
        line-height: normal !important;
    }

    /* Match mdi checkbox size used in metrics/columns lists (18px). */
    .metric-filter-checkbox :deep(.q-checkbox__inner) {
        font-size: 18px !important;
        width: 18px !important;
        height: 18px !important;
        min-width: 18px !important;
    }

    .metric-filter-checkbox :deep(.q-checkbox__svg) {
        width: 18px;
        height: 18px;
    }
</style>
